// @ts-nocheck
/* eslint-disable */
export class VarbitID {}
VarbitID.FARMING_TRANSMIT_A = 4771
VarbitID.FARMING_TRANSMIT_B = 4772
VarbitID.FARMING_TRANSMIT_C = 4773
VarbitID.FARMING_TRANSMIT_D = 4774
VarbitID.FARMING_TRANSMIT_E = 4775
VarbitID.FARMING_TRANSMIT_F = 7904
VarbitID.FARMING_TRANSMIT_G = 7905
VarbitID.FARMING_TRANSMIT_H = 7906
VarbitID.FARMING_TRANSMIT_I = 7907
VarbitID.FARMING_TRANSMIT_J = 7908
VarbitID.FARMING_TRANSMIT_K = 7909
VarbitID.FARMING_TRANSMIT_L = 7910
VarbitID.FARMING_TRANSMIT_M = 7911
VarbitID.FARMING_TRANSMIT_N = 7912
VarbitID.FARMING_TRANSMIT_O = 7913
VarbitID.FARMING_TRANSMIT_P = 7914
VarbitID.FARMING_TRANSMIT_A1 = 4953
VarbitID.FARMING_TRANSMIT_A2 = 4954
VarbitID.FARMING_TRANSMIT_B1 = 4955
VarbitID.FARMING_TRANSMIT_B2 = 4956
VarbitID.FARMING_TRANSMIT_C1 = 4957
VarbitID.FARMING_TRANSMIT_C2 = 4958
VarbitID.FARMING_TRANSMIT_D1 = 4959
VarbitID.FARMING_TRANSMIT_D2 = 4960
VarbitID.FARMING_TRANSMIT_E1 = 4961
VarbitID.FARMING_TRANSMIT_E2 = 4962
VarbitID.FARMING_TRANSMIT_F1 = 4963
VarbitID.FARMING_TRANSMIT_F2 = 4964
VarbitID['__class'] = 'timetracking.VarbitID'
